export default "__VITE_ASSET__0f737a6a__"